export default "__VITE_ASSET__BrYUVut3__"